import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TOTAL_PRICE: `${cleanedFilename(__filename)}-total-price`,
};
